import { connect, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../redux/reducers/reducer';
import CreatePrivateTemplateModuleTagModal from './module-tag/createTagWindow/CreatePrivateTemplateModuleTagModal';
import store from '../../../../redux/store/store';
import { onThunkCloseCreateModuleWindow } from '../../../../redux/thunk-creators/moduleWindow';
import TagsMenuModalWrapper from './module-tag/tagMenuModal/TagsMenuModalWrapper';
import TagsGroupMenuModalWrapper from './module-tag/tagMenuModal/TagsGroupMenuModalWrapper';
import DeletingTagWrapper from './module-tag/deletingTagWindow/DeletingTagWrapper';
import DeletingTagGroupWrapper from './module-tag/deletingTagWindow/DeletingTagGroupWrapper';
import EditingTagWrapper from './module-tag/editTagWindow/EditingTagWrapper';
import EditingTagGroupWrapper from './module-tag/editTagWindow/EditingTagGroupWrapper';
import { categoryModalsActive } from '../../../../redux/selectors/module/category';
import { tagModalsActive } from '../../../../redux/selectors/module/tag';
import { tagsGroupModalsActive } from '../../../../redux/selectors/module/tagGroup';
import { all, moduleModalsActive } from '../../../../redux/selectors/module/module';
import UnbindTagWrapper from './module-tag/deletingTagWindow/UnbindTagWrapper';
import MultipleTagSelectionWindow
	from './editModuleWindow/editBlocks/tagGroupBlock/group/multipleTagSelectionWindow/MultipleTagSelectionWindow';
import CreateModuleWindowContainer from './createModuleWindow/CreateModuleWindowContainer';
import CreateTableModal from '../createTableModal/CreateTableModal';
import { NewModal } from '../../../ui/modals/new-modal';
import CreateTagGroupWindow from './module-tag/createTagGroupWindow/CreateTagGroupWindow';
import { DeleteCategoryModal } from '../../../../features/category/delete';
import { EditCategoryModal } from '../../../../features/category/edit';
import { CreateCategoryModal } from '../../../../features/category/create/ui/create-category-modal';
import {
	moduleWindow,
	setCreateModuleWindowPreview
} from '../../../../entities/module/private-template-module/model/slice';
import {
	CreateWorkshopModuleModal,
} from '../../../../features/manage-workshop-module';
import { EditingPrivateTemplateModulesModal } from '../../../../widgets/editing-private-template-modules-modal';
import { WorkshopModulesModal } from '../../../../widgets/modules-modal/workshop-modules-modal/ui/modal/WorkshopModulesModal';
import { PrivateTemplateModulesModal } from '../../../../widgets/modules-modal/private-template-modules-modal';
import { BindWorkshopModuleTagModal } from '../../../../widgets/workshop-module-bind-tag-modal';
import { EditingWorkshopModulesModal } from '../../../../widgets/editing-workshop-modules-modal';
import {
	BindWorkshopModuleCategoryModal,
} from '../../../../widgets/workshop-module-bing-category-modal';
import { AiCategoryModal } from '../../../../features/ai/ui/ai-category-modal/ai-category-modal';
import DeletingTemplateTagWrapper from '../templateGroupTag/tag/deletingTagWindow/DeletingTemplateTagWrapper';
import EditingTemplateTagWrapper from '../templateGroupTag/tag/editTagWindow/EditingTemplateTagWrapper';
import DeletingTagGroupModalWrapper from '../templateGroupTag/group-tag/DeletingTagGroupModalWrapper';
import DeletingModuleTagWrapper from '../moduleGroupTag/template/tag/deletingTagWindow/DeletingModuleTagWrapper';
import DeletingWorkshopModuleTagWrapper
	from '../moduleGroupTag/workshop/tag/deletingTagWindow/DeletingWorkshopModuleTagWrapper';
import EditingWorkshopModuleTagWrapper
	from '../moduleGroupTag/workshop/tag/editTagWindow/EditingWorkshopModuleTagWrapper';
import {
	CreatePrivateTemplateModuleTagGroupModal,
} from '../../../../features/module/private-module-tag-group/ui/create-group-modal';
import EditingTemplateModuleTagWrapper
	from '../moduleGroupTag/template/tag/editTagWindow/EditingTemplateModuleTagWrapper';
import DeletingTemplateTagGroupModalWrapper
	from '../moduleGroupTag/template/group-tag/DeletingTemplateTagGroupModalWrapper';
import {
	CreateWorkshopModuleTagGroupModal,
// eslint-disable-next-line max-len
} from '../../../../features/module/tag-group/workshop-module-tag-group-settings/ui/Create-group-modal/CreateWorkshopModuleTagGroupModal';
import {
	WorkshopModuleTagGroupDeletingModal,
} from '../../../../features/modal/workshop-module-tag-group-deleting-modal/WorkshopModuleTagGroupDeletingModal';
import { PrivateTemplateInfoModalWrapper } from '../../collection/section/template/private/ui/modals/info/info';
import { WorkshopTemplateInfoModalWrapper } from '../../../../features/workshop/templates/info';
import { useAppSelector } from '../../../../shared/libs/redux';
import { templateModuleActions, templateModuleSelectors } from '../../../../entities/template-module';

interface IModuleWindowWrapperProps {
	setCreateTemplateWindowPreview: (preview: string) => void;
}

const ModalsWrapper: React.FC = () => {
	const {
		isCreateModuleWindowOpen,
	} = useSelector((state: RootState) => moduleModalsActive(state));

	const {
		isEditCategoryModalActive,
		isCreatingCategoryModalActive,
		isDeletingCategoryModalActive,
	} = useSelector((state: RootState) => categoryModalsActive(state));

	const {
		isCreatingTagModalActive,
		isEditingTagModalActive,
		isDeletingTagModalActive,
	} = useSelector((state: RootState) => tagModalsActive(state));

	const {
		isEditTagGroupModalActive,
		isDeletingTagGroupModalActive,
		isCreatingTagGroupModalActive,
		isUnbindingTagGroupModalActive,
		isBindingTagGroupModalActive,
	} = useSelector((state: RootState) => tagsGroupModalsActive(state));

	// const onHandleCreateModuleWindow = (value: boolean) => {
	// 	if (!value && isCreateModuleWindowOpen) {
	// 		store.dispatch(onThunkCloseCreateModuleWindow() as any);
	// 	}
	// };

	const editor = useAppSelector(moduleWindow.selectors.getEditor);

	const handleTemplateModal = (value: boolean) => {
		if (!value && isCreateModuleWindowOpen) {
			store.dispatch(moduleWindow.actions.setCreateModuleWindowOpen({ editor, active: value }));
		}
	};

	return (
		<>
			<EditingWorkshopModulesModal />
			<PrivateTemplateModulesModal />
			<BindWorkshopModuleTagModal />
			<BindWorkshopModuleCategoryModal />

			<EditingPrivateTemplateModulesModal
				modalInModalActive={
					isCreatingCategoryModalActive
					|| isEditCategoryModalActive
					|| isDeletingCategoryModalActive

					|| isEditingTagModalActive
					|| isDeletingTagModalActive
					|| isCreatingTagModalActive

					|| isEditTagGroupModalActive
					|| isDeletingTagGroupModalActive
					|| isUnbindingTagGroupModalActive
					|| isBindingTagGroupModalActive
					|| isCreatingTagGroupModalActive
				}
			/>
			<CreateWorkshopModuleTagGroupModal />
			<DeletingTagGroupWrapper />
			<DeletingTagGroupModalWrapper />
			<DeletingTemplateTagGroupModalWrapper />
			<WorkshopModuleTagGroupDeletingModal />
			<EditingTagGroupWrapper />
			<UnbindTagWrapper />
			<MultipleTagSelectionWindow />
			<EditCategoryModal />
			<EditingTagWrapper />
			<DeletingTagWrapper />
			<DeletingModuleTagWrapper />
			<DeletingWorkshopModuleTagWrapper />
			<EditingWorkshopModuleTagWrapper />
			<EditingTemplateModuleTagWrapper />
			<PrivateTemplateInfoModalWrapper />
			<WorkshopTemplateInfoModalWrapper />
			<DeleteCategoryModal />
			<EditingTemplateTagWrapper />
			<DeletingTemplateTagWrapper />
			<TagsMenuModalWrapper
				modalInModalActive={
					isEditingTagModalActive
					|| isDeletingTagModalActive
					|| isCreatingTagModalActive
				}
			/>
			<TagsGroupMenuModalWrapper
				modalInModalActive={
					isEditTagGroupModalActive
					|| isDeletingTagGroupModalActive
					|| isCreatingTagGroupModalActive
				}
			/>
			<CreateWorkshopModuleModal />
			<CreateCategoryModal />
			<CreateTagGroupWindow />
			<CreatePrivateTemplateModuleTagGroupModal />
			<CreateTableModal />
			<CreatePrivateTemplateModuleTagModal />
			<WorkshopModulesModal />
			<AiCategoryModal />
			<NewModal
				active={isCreateModuleWindowOpen}
				closeFunc={(value) => handleTemplateModal(value)}
			>
				<CreateModuleWindowContainer
					isModalActive={isCreateModuleWindowOpen}
				/>
			</NewModal>
		</>
	);
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setCreateModuleWindowPreview: (value: string) => dispatch(setCreateModuleWindowPreview(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalsWrapper);
